import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { FormControl, ControlLabel, Row, Col } from 'react-bootstrap';
import { push } from 'react-router-redux';
import { isBroker, isBrokerOrganisation } from '../../../auth/redux/authActions';
import { InternalButtonBar } from '../../../layout/components/InternalButtonBar/InternalButtonBar';

export default class RoleList extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    role: PropTypes.object.isRequired,
  };

  handleRowClick(row) {
    this.props.dispatch(push('/admin/roles/' + row.id));
  }

  handleSearchUpdate(event) {
    this.props.dispatch(applyFilter('roles', 'filter[name]', event.target.value));
  }

  render() {
    const autoFilters =
      isBroker() || isBrokerOrganisation()
        ? [{ type: 'filter[name]', value: 'Broker' }]
        : [];
    return (
      <div>
        <Box>
          <Row>
            <Col sm={5}>
              <ControlLabel>Search</ControlLabel>
              <FormControl onChange={::this.handleSearchUpdate} />
            </Col>
          </Row>
        </Box>

        <Box>
          <DataTable
            source="/roles"
            name="roles"
            showTotal
            autoFilters={autoFilters}
            onRowSelect={this.handleRowClick.bind(this)}
          >
            <TableHeaderColumn dataField="id" isKey hidden />

            <TableHeaderColumn dataField="name" dataSort width={'150px'}>
              Name
            </TableHeaderColumn>

            <TableHeaderColumn dataField="description" dataSort width={'300px'}>
              Description
            </TableHeaderColumn>
          </DataTable>

          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['role.create'],
                    button: (
                      <Button
                        link
                        to="/admin/roles/new"
                        className="pull-right"
                        bsStyle="primary"
                        label="New Role"
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </Box>
      </div>
    );
  }
}
